import * as React from 'react';
import Box from '@mui/material/Box';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CommonSlider } from './slider-styles';

interface Iprops {
    sliderOpen: boolean;
    sliderClose: () => void;
    drawerList: React.JSX.Element;
}
export const CustomSlider: React.FC<Iprops> = ({ sliderOpen, sliderClose, drawerList }) => {
    return (
        <Box>
            <CommonSlider anchor="right" open={sliderOpen}>
                <Box className="sliderContent">
                    <IconButton
                        className="closeBtn"
                        onClick={sliderClose}
                        sx={{
                            width: 42,
                            height: 42,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {drawerList}
                </Box>
            </CommonSlider>
        </Box>
    );
};
